var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',[_c('v-row',{staticClass:"mt-5"},[_c('v-col',{staticClass:"p-3",attrs:{"sm":"4"}},[_c('v-card',{staticClass:"m-shadow"},[_c('div',{attrs:{"id":"reader","width":"600px"}})])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }